import { styled, Button, Input } from '@clickcease/cc-client-components-lib'

export const CouponWrapper = styled('div', {
  width: '100%',
  fontSize: '$md',
  marginBottom: '15px',
})

export const CouponTitle = styled('div', {
  fontSize: '$md',
  marginBottom: '5px',
})

export const CouponInputWrapper = styled('div', {
  display: 'flex',
  fontSize: '$md',
  justifyContent: 'space-between',
})

export const CouponInput = styled(Input, {
  height: '38px',
  width: '67%',

  '@bp1': {
    width: '60%',
  },
})

export const CouponError = styled('div', {
  fontWeight: '$r',
  fontSize: '$sm',
  color: '$error',
  marginTop: '5px',
})

export const ValidCoupon = styled('div', {
  fontWeight: '$r',
  fontSize: '$sm',
  color: '$success',
  marginTop: '5px',
})

export const CouponButton = styled(Button, {
  height: '20px',
  width: '30%',
  border: '1px solid $primaryColor',
})
